/* =============================================================
   Breed Types Filter — breed-types.js
   File path: assets/breed-types.js
   ============================================================= */

(function () {
  'use strict';

  function initBreedFilter() {
    var filterBtns = document.querySelectorAll('.bt-filter-btn');
    var cards = document.querySelectorAll('.bt-card');

    if (!filterBtns.length || !cards.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var size = this.getAttribute('data-filter');

        /* Update button states */
        filterBtns.forEach(function (b) {
          b.classList.remove('bt-filter-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('bt-filter-btn--active');
        this.setAttribute('aria-pressed', 'true');

        /* Show / hide cards */
        cards.forEach(function (card) {
          if (size === 'all' || card.getAttribute('data-size') === size) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreedFilter);
  } else {
    initBreedFilter();
  }
})();